/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Waiting_Room_BodyInputs */



/**
* | output |
* | --- |
* | "The organiser still has to let the notetaker in. It is called \"Wundo\" in the list of people waiting." |
*
* @param {Meeting_Notetaker_Issue_Waiting_Room_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_room_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Waiting_Room_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_Room_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De organisator moet de notetaker nog binnenlaten. Hij heet \"Wundo\" in de lijst met wachtenden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'organisateur doit encore laisser entrer le notetaker. Il s'appelle \"Wundo\" dans la liste d'attente.")
	return /** @type {LocalizedString} */ ("The organiser still has to let the notetaker in. It is called \"Wundo\" in the list of people waiting.")
});